import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e6c6bf5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "package-detail" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "name ws_mt45" }
const _hoisted_4 = { class: "mode ws_mt30" }
const _hoisted_5 = { class: "table ws_border_t" }

import { ref } from 'vue'
import { getPackageInfo } from '@/api'
import { useRoute } from 'vue-router'
import { CODE_ENUM } from '@/common'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const $route = useRoute()
const id = $route.query.id || ''

const detailData: any = ref({})
const queryDetail = async () => {
  const res: any = await getPackageInfo({
    id,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    detailData.value = res.data
  }
}

const tableLoading = ref(false)

const tableData = ref([])
const init = async () => {
  tableLoading.value = true
  await queryDetail().finally(() => {
    tableLoading.value = false
  })
  const applicationDataList = detailData.value.applicationDataList || []
  const result = applicationDataList.reduce((mo: any, el: any) => {
    const { directories } = el

    mo.push({
      appName: el.name,
    })

    const directoryList = (directories || []).map((directory: any) => {
      const { name, menues } = directory
      mo.push({
        directoryName: name,
      })
      const list = menues.map((item: any) => {
        const menueResult = (item.children || []).reduce(
          (m: any, e: any, index: number) => {
            m.push({
              menuName: index === 0 ? item.name : '',
              resourceName: e.name,
              desc: e.describe,
              id: e.id,
              buttonName: e.buttonName,
            })
            return m
          },
          []
        )
        return menueResult
      })
      mo = mo.concat(list.flat(Infinity))
    })
    return mo
  }, [])

  tableData.value = result
}

init()

const tableColumn: any = [
  {
    prop: 'appName',
    label: '应用',
    width: '130px',
  },
  {
    prop: 'directoryName',
    label: '目录',
    width: '130px',
  },
  {
    prop: 'resourceName',
    label: '资源名称',
    width: '180px',
  },
  {
    prop: 'desc',
    label: '资源描述',
  },
]

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(detailData.value.packageName), 1),
      _createElementVNode("p", _hoisted_4, "计费模式 ：" + _toDisplayString(detailData.value.chargeModeName), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_table, {
        data: tableData.value,
        border: true,
        class: "ws_common_table ws_mt24"
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, { description: "暂无数据" })
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableColumn, (item, index) => {
            return _createVNode(_component_el_table_column, _mergeProps({ key: index }, {
            ...item,
          }), null, 16)
          }), 64))
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ])), [
    [_directive_loading, tableLoading.value]
  ])
}
}

})